import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { Checkbox, Divider } from 'antd';

import { SET_FILTERS_SECTORS } from '~/redux/actions/DatailedReportFiltersActions';
import { ToastContext } from '~/providers/ToastProvider';
import { SectorRoutes } from '~/http/routes';

function Sector() {
	const dispatch = useDispatch();
	const { companyId } = useSelector(state => state.userStore);
	const { sectors } = useSelector(state => state.detailedReportFilters);

	const { setToast } = useContext(ToastContext);
	const [companySectors, setCompanySectors] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(async () => {
		try {
			setCompanySectors((await SectorRoutes.getSector(companyId)).data.data);
			setIsLoading(false);
		} catch (err) {
			setToast({
				type: 'error',
				title: 'Erro!',
				message: 'Um erro ocorreu ao buscar os setores da empresa!',
				show: true,
				autohide: true,
			});
			setIsLoading(false);
		}
	}, []);

	function setSectors(e) {
		dispatch({ type: SET_FILTERS_SECTORS, data: e });
	}

	function handleCheck(e) {
		const aux = sectors;
		const index = aux.findIndex(sc => sc == e);

		if (index > -1)
			aux.splice(index, 1);
		else
			aux.push(e);

		setSectors(aux);
	}

	function handleCheckAll(e) {
		if (e.target.checked)
			setSectors(companySectors.map(e => e.id));
		else
			setSectors([]);
	}

	if (isLoading)
		return (
			<div className="d-flex justify-content-center">
				<Spinner animation="border"
					role="status" />
			</div>
		);

	return (
		<>
			<div className="row">
				<div className="col-sm-12">
					<Checkbox checked={sectors.length === companySectors.length}
						indeterminate={sectors.length !== companySectors.length}
						onChange={handleCheckAll}>
						Marcar todos
					</Checkbox>
				</div>

				<Divider />
			</div>

			<div className="row">
				{companySectors.map(({ name, id }, i) => (
					<div key={i}
						className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
						<Checkbox checked={sectors.find(e => e == id)}
							onChange={handleCheck.bind(null, id)}>
							{name}
						</Checkbox>

						<Divider />
					</div>
				))}
			</div>
		</>
	);
}

export default Sector;
